<template>
    <nut-tabbar :tabbar-list="tabList" :bottom="true"></nut-tabbar>
</template>

<script>
    export default {
        name: "tabbar",
        props:['index'],
        data() {
            return {
                tabList:[],
            }
        },
        watch:{
            index(){
                this.tabList = this.getTabList(this.index);
            }
        },
        mounted() {
            this.tabList = this.getTabList(this.index);
        },
        methods:{
            getTabList(index) {
                let list = [
                    {
                        'tabTitle':'主页',
                        'curr':index == 0,
                        'icon':require('../assets/image/tabbar/home.jpg'),
                        'activeIcon':require('../assets/image/tabbar/home-fill.jpg'),
                        'href':'/#/home'
                    },
                    {
                        'tabTitle':'分类',
                        'curr':index == 1,
                        'icon':require('../assets/image/tabbar/cat.jpg'),
                        'activeIcon':require('../assets/image/tabbar/cat-fill.jpg'),
                        'href':'/#/cat'
                    },
                    {
                        'tabTitle':'优惠',
                        'curr':index == 2,
                        'icon':require('../assets/image/tabbar/rp.jpg'),
                        'activeIcon':require('../assets/image/tabbar/rp-fill.jpg'),
                        'href':'/#/actList'
                    },
                    {
                        'tabTitle':'我的',
                        'curr':index == 3,
                        'icon':require('../assets/image/tabbar/mine.jpg'),
                        'activeIcon':require('../assets/image/tabbar/mine-fill.jpg'),
                        'href':'/#/mine'
                    }
                ]
                return list;
            }
        }
    }
</script>

<style>
    .nut-tabbar{
        height: 50px!important;
        border-bottom:none!important; ;
    }
    .tabbar-nav-word{
        display: block;
    }
    .tabbar-nav .icon-box .icon{
        width: 20px;height: 20px;
    }
</style>